import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSupabaseClient } from '../lib/supabase';

/**
 * JoinSession component - redirects authenticated users to the waiting room
 * for the specified session. Redirects to login if not authenticated.
 */
const JoinSession: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      const supabase = getSupabaseClient();
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        // User is logged in, redirect to waiting room
        navigate(`/home/waiting-room?sessionId=${sessionId}`, { replace: true });
      } else {
        // User is not logged in, redirect to login with return URL
        const returnUrl = `/join/${sessionId}`;
        navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`, { replace: true });
      }

      setChecking(false);
    };

    checkAuthAndRedirect();
  }, [sessionId, navigate]);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#FFFCEF] flex items-center justify-center">
        <div className="text-[#2C2731]/70">Redirecting...</div>
      </div>
    );
  }

  return null;
};

export default JoinSession;
